export * from './AudioContainer/audio.actions'

export const INIT = 'GAME_INIT'
export const ADD_POPUP = 'GAME_ADD_POPUP'
export const ADD_ACTION = 'GAME_ADD_ACTION'
export const ADD_SCREEN_FINISH = 'GAME_ADD_SCREEN_FINISH'
export const ADD_SCREEN_START = 'GAME_ADD_SCREEN_START'
export const CHANGE_SCENE_FINISH = 'GAME_CHANGE_SCENE_FINISH'
export const CHANGE_SCENE_START = 'GAME_CHANGE_SCENE_START'
export const CLEAR_ALL_SCREENS = 'GAME_CLEAR_ALL_SCREENS'
export const CLEAR_ALL_POPUPS = 'GAME_CLEAR_ALL_POPUPS'
export const HIDE_ERROR = 'GAME_HIDE_ERROR'
export const HIDE_SCENE_TRANSITION = 'GAME_HIDE_SCENE_TRANSITION'
export const NEXT_SCENES_LAZYLOAD_START = 'GAME_NEXT_SCENES_LAZYLOAD_START'
export const PROMPT_FULLSCREEN = 'GAME_PROMPT_FULLSCREEN'
export const REGISTER_COMPONENTS = 'GAME_REGISTER_COMPONENTS'
export const RELOAD = 'GAME_RELOAD'
export const REMOVE_SCREEN_FINISH = 'GAME_REMOVE_SCREEN_FINISH'
export const REMOVE_SCREEN_START = 'GAME_REMOVE_SCREEN_START'
export const REMOVE_POPUP = 'GAME_REMOVE_POPUP'
export const RESIZE_FINISH = 'GAME_RESIZE_FINISH'
export const RESIZE_START = 'GAME_RESIZE_START'
export const RETURN_TO_PLATFORM = 'GAME_RETURN_TO_PLATFORM'
export const SAVEPOINT_SYNC_GAME = 'SAVEPOINT_SYNC_GAME'
export const SCENE_PRELOAD_START = 'GAME_SCENE_PRELOAD_START'
export const SET_DEVICE_INFO = 'GAME_SET_DEVICE_INFO'
export const SET_SCREENS = 'GAME_SET_SCREENS'
export const SHOW_ERROR = 'GAME_SHOW_ERROR'
export const SHOW_MEDIA = 'GAME_SHOW_MEDIA'
export const SHOW_SCENE_TRANSITION = 'GAME_SHOW_SCENE_TRANSITION'
export const TOGGLE_CONSUME_WARNING = 'GAME_TOGGLE_CONSUME_WARNING'
export const UNIVERSAL_CLICK = 'GAME_UNIVERSAL_CLICK'
export const UNIVERSAL_TOUCH_START = 'GAME_UNIVERSAL_TOUCH_START'
export const UNIVERSAL_TOUCH_END = 'GAME_UNIVERSAL_TOUCH_END'
export const UNIVERSAL_MOUSE_LEAVE = 'GAME_UNIVERSAL_MOUSE_LEAVE'
export const UNIVERSAL_MOUSE_UP = 'GAME_UNIVERSAL_MOUSE_UP'
export const UNIVERSAL_MOUSE_DOWN = 'GAME_UNIVERSAL_MOUSE_DOWN'
export const UNIVERSAL_DROP = 'GAME_UNIVERSAL_DROP'
export const UNIVERSAL_DRAG_END = 'GAME_UNIVERSAL_DRAG_END'
export const USERINFO_SYNC_GAME = 'USERINFO_SYNC_GAME'
export const FIRST_CLICK = 'GAME_FIRST_CLICK'
export const SET_CURSOR_POSITION = 'GAME_SET_CURSOR_POSITION'

export const addAction = (action) => {
  return { type: ADD_ACTION, data: action }
}
export const addPopup = (popupId) => {
  return { type: ADD_POPUP, data: popupId }
}
export const firstClick = (firstTouch) => {
  return { type: FIRST_CLICK, data: firstTouch }
}
export const addScreen = (screenId) => {
  return { type: ADD_SCREEN_START, data: screenId }
}
export const broadcastUniversalClick = (target) => {
  return { type: UNIVERSAL_CLICK, data: target }
}
export const broadcastUniversalTouch = (target) => {
  return { type: UNIVERSAL_TOUCH_START, data: target }
}
export const broadcastUniversalTouchEnd = (target) => {
  return { type: UNIVERSAL_TOUCH_END, data: target }
}
export const broadcastUniversalMouseUp = (target) => {
  return { type: UNIVERSAL_MOUSE_UP, data: target }
}
export const broadcastUniversalMouseDown = (target) => {
  return { type: UNIVERSAL_MOUSE_DOWN, data: target }
}
export const broadcastUniversalMouseLeave = (target) => {
  return { type: UNIVERSAL_MOUSE_LEAVE, data: target }
}
export const broadcastUniversalDrop = (target) => {
  return { type: UNIVERSAL_DROP, data: target }
}
export const broadcastUniversalDragEnd = (target) => {
  return { type: UNIVERSAL_DRAG_END, data: target }
}
export const clearAllScreens = () => ({
  type: CLEAR_ALL_SCREENS,
})
export const clearAllPopups = () => ({
  type: CLEAR_ALL_POPUPS,
})
export const finishResize = () => {
  return { type: RESIZE_FINISH }
}
export const finishSceneChange = (sceneId) => {
  return { type: CHANGE_SCENE_FINISH, data: sceneId }
}
export const hideError = () => {
  return { type: HIDE_ERROR }
}
export const hideSceneTransition = () => {
  return { type: HIDE_SCENE_TRANSITION }
}
export const initGame = () => {
  return { type: INIT }
}
export const promptFullscreen = () => {
  return { type: PROMPT_FULLSCREEN }
}
export const registerComponents = (components) => {
  return { type: REGISTER_COMPONENTS, data: components }
}
export const reload = () => {
  return { type: RELOAD }
}
export const toggleConsumeWarning = (showConsumeWarning) => {
  return { type: TOGGLE_CONSUME_WARNING, data: showConsumeWarning }
}
export const removePopup = (popupId) => {
  return { type: REMOVE_POPUP, data: popupId }
}
export const removeScreen = (screenId) => {
  return { type: REMOVE_SCREEN_START, data: screenId }
}
export const returnToPlatform = () => {
  return { type: RETURN_TO_PLATFORM }
}
export const setDeviceInfo = (deviceInfo) => {
  return { type: SET_DEVICE_INFO, data: deviceInfo }
}
export const setScreens = (data) => ({
  type: SET_SCREENS,
  data,
})
export const showSceneTransition = () => {
  return { type: SHOW_SCENE_TRANSITION }
}
export const startSceneChange = (nextSceneId) => {
  return { type: CHANGE_SCENE_START, data: nextSceneId }
}
export const startResize = () => {
  return { type: RESIZE_START }
}
export const showError = (errorType) => {
  return { type: SHOW_ERROR, data: errorType }
}
export const showMedia = () => {
  return { type: SHOW_MEDIA }
}
export const startNextScenesLazyload = (sceneId) => {
  return { type: NEXT_SCENES_LAZYLOAD_START, data: sceneId, next: true }
}
export const startScenePreload = (sceneId) => {
  return { type: SCENE_PRELOAD_START, data: sceneId, next: false }
}
export const syncWithSavePoint = (savePoint) => {
  return { type: SAVEPOINT_SYNC_GAME, data: savePoint }
}
export const setCursorPosition = (event) => {
  return { type: SET_CURSOR_POSITION, data: event }
}
